export {
    REACT_TABLE_TRANSLATIONS
} from "./commonTranslations";

export const LONG_DATE_TIME_FORMAT = 'LLL';
export const MEDIUM_DATE_TIME_FORMAT = 'lll';
export const DATE_FORMAT = 'DD.MM.YYYY';
export const INPUT_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

export const SHORT_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';